import { render, staticRenderFns } from "./Shoppable.vue?vue&type=template&id=4f01c9db"
import script from "./Shoppable.vue?vue&type=script&lang=js"
export * from "./Shoppable.vue?vue&type=script&lang=js"
import style0 from "./Shoppable.vue?vue&type=style&index=0&id=4f01c9db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports